export enum UserRole {
  SYSTEM_ADMIN = 'system_admin',
  MONITOR = 'monitor',
  BUSINESS_OWNER = 'business_owner',
  BUSINESS_EMPLOYEE = 'business_employee',
  BUSINESS_CASHIER = 'business_cashier',
  CLIENT = 'client'
}